import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import EmployeeEvaluationForm from './EmployeeEvaluationForm';
import { createHREmployeeEvaluation } from '../../../../actions/HumanResources/employeeEvaluationActions';
import { getEmployees } from '../../../../actions/HumanResources/employeeActions';
import _ from 'lodash';
import LoadingSpinner from '../../../../components/LoadingSpinner';

const EmployeeEvaluationCreate = (props) => {
	const { datas, loading } = props;

	const onSubmit = (formValues) => {
		if (!_.isEmpty(formValues)) {
			props.createHREmployeeEvaluation(formValues);
		}
	};

	useEffect(() => {
		props.getEmployees();
	}, []);

	return (
		<>
			{loading ? (
				<LoadingSpinner />
			) : (
				<div>
					<EmployeeEvaluationForm datas={datas} onSubmit={onSubmit} />
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		humanResources: {
			employee: { employees, getEmployeesLoading },
		},
	} = state;

	return {
		datas: { employees },
		loading: getEmployeesLoading,
	};
};

export default connect(mapStateToProps, { createHREmployeeEvaluation, getEmployees })(EmployeeEvaluationCreate);
